import type { ProjectArchiveEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const ArchiveIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<rect x="2" y="2.5" width="12" height="3" rx="0.5" />
		<path d="M3 5.5v7a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-7" />
		<path d="M6.5 8.5h3" />
	</svg>
)

export function ProjectArchiveRow({ event }: { event: ProjectArchiveEvent }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	const copy =
		event.type === "project.archived"
			? t.journal.events.projectArchived
			: t.journal.events.projectUnarchived
	return (
		<JournalRowShell
			icon={<ArchiveIcon />}
			headline={copy.label}
			actor={actor}
			iso={event.createdAt}
			eventType={event.type}
			aria={interpolate(copy.aria, { actor })}
		/>
	)
}
